import JumboScrollbar from '@jumbo/components/JumboScrollbar';
import { Card, Grid, Typography } from '@mui/material';
import DashboardStatListCard from './DashboardStatListCard';


function DashboardUserInfoMeetingsCard({ countList }) {

    return (

        <Card
            sx={{
                backgroundColor: '#FFFFFF',
                borderRadius: '8px',
                boxShadow: 2,
                padding: '10px',
                minHeight: '190px'
            }}
        >
            <JumboScrollbar
                autoHeight
                autoHeightMin={180}
                autoHide
                autoHideDuration={200}
                autoHideTimeout={500}
            >
                <Typography

                    sx={{ fontSize: '13px', padding: '5px', paddingBottom: '10px' }}
                >
                    Üye/Katılımcı Olarak Katıldığınız Toplantılar
                </Typography>
                <Grid container spacing={1} direction="row">
                    <Grid item xs={6} md={6} lg={6}>
                        <DashboardStatListCard countList={countList} type={"attented"} />
                    </Grid>
                    <Grid item xs={6} md={6} lg={6}>
                        <DashboardStatListCard countList={countList} type={"ongoing"} />
                    </Grid>
                </Grid>
            </JumboScrollbar>
        </Card>


    );
};
export default DashboardUserInfoMeetingsCard
